import { useMutation, useQueryClient } from "@tanstack/react-query";
import collectionApiClient, { DateValue } from "../../../api/collection";

const useSetCollectionEtaMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ["set-collection-eta"],
    mutationFn: ({
      collectionId,
      eta,
    }: {
      collectionId: string;
      eta?: DateValue;
    }) => collectionApiClient.setCollectionEta(collectionId, eta),
    onSettled: () => {
      queryClient.refetchQueries({ queryKey: ["collections"] });
      queryClient.refetchQueries({ queryKey: ["draft-collections"] });
    },
  });
};

export default useSetCollectionEtaMutation;
